import axiosautomacao from "../apigestao"
const { 
  GET_LOYALTY_SETTINGS,
  GET_ALL_LOYALTY_SETTINGS,
  ADD_LOYALTY_SETTINGS,
  UPDATE_LOYALTY_SETTINGS,
  DELETE_LOYALTY_SETTINGS,
  GET_LOYALTY_SETTINGS_BY_ENTERPRISE,
  GET_ALL_LOYALTY_RULES_EARN,
  GET_LOYALTY_RULES_EARN,
  ADD_LOYALTY_RULES_EARN,
  UPDATE_LOYALTY_RULES_EARN,
  DELETE_LOYALTY_RULES_EARN,
  GET_LOYALTY_RULES_EARN_BY_ENTERPRISE,
  REDEEM_LOYALTY_POINTS,
  GET_LOYALTY_LEDGER
} = require("./actions/loyalty");

const moduleLoyalty = {
  state: () => ({
    // Settings
    loyaltySettings: {},
    allLoyaltySettings: {},
    selectedLoyaltySettings: {},
    
    // Rules Earn
    loyaltyRulesEarn: {},
    allLoyaltyRulesEarn: {},
    selectedLoyaltyRulesEarn: {},
    
    // Customer
    loyaltyLedger: {},
    
    // Loading states
    isLoading: false,
    isLoadingSettings: false,
    isLoadingRules: false,
  }),

  mutations: {
    // Settings mutations
    GET_LOYALTY_SETTINGS: (state, payload) => {
      state.selectedLoyaltySettings = payload;
    },
    GET_ALL_LOYALTY_SETTINGS: (state, payload) => {
      state.allLoyaltySettings = payload;
    },
    ADD_LOYALTY_SETTINGS: (state, payload) => {
      if (state.allLoyaltySettings.data) {
        state.allLoyaltySettings.data.push(payload);
      }
    },
    UPDATE_LOYALTY_SETTINGS: (state, payload) => {
      if (state.allLoyaltySettings.data) {
        const index = state.allLoyaltySettings.data.findIndex(item => item.id === payload.id);
        if (index !== -1) {
          state.allLoyaltySettings.data.splice(index, 1, payload);
        }
      }
      state.selectedLoyaltySettings = payload;
    },
    DELETE_LOYALTY_SETTINGS: (state, id) => {
      if (state.allLoyaltySettings.data) {
        state.allLoyaltySettings.data = state.allLoyaltySettings.data.filter(item => item.id !== id);
      }
    },
    
    // Rules Earn mutations
    GET_LOYALTY_RULES_EARN: (state, payload) => {
      state.selectedLoyaltyRulesEarn = payload;
    },
    GET_ALL_LOYALTY_RULES_EARN: (state, payload) => {
      state.allLoyaltyRulesEarn = payload;
    },
    ADD_LOYALTY_RULES_EARN: (state, payload) => {
      if (state.allLoyaltyRulesEarn.data) {
        state.allLoyaltyRulesEarn.data.push(payload);
      }
    },
    UPDATE_LOYALTY_RULES_EARN: (state, payload) => {
      if (state.allLoyaltyRulesEarn.data) {
        const index = state.allLoyaltyRulesEarn.data.findIndex(item => item.id === payload.id);
        if (index !== -1) {
          state.allLoyaltyRulesEarn.data.splice(index, 1, payload);
        }
      }
      state.selectedLoyaltyRulesEarn = payload;
    },
    DELETE_LOYALTY_RULES_EARN: (state, id) => {
      if (state.allLoyaltyRulesEarn.data) {
        state.allLoyaltyRulesEarn.data = state.allLoyaltyRulesEarn.data.filter(item => item.id !== id);
      }
    },
    
    // Customer mutations
    GET_LOYALTY_LEDGER: (state, payload) => {
      state.loyaltyLedger = payload;
    },
    
    // Loading mutations
    SET_LOYALTY_LOADING: (state, isLoading) => {
      state.isLoading = isLoading;
    },
    SET_LOYALTY_SETTINGS_LOADING: (state, isLoading) => {
      state.isLoadingSettings = isLoading;
    },
    SET_LOYALTY_RULES_LOADING: (state, isLoading) => {
      state.isLoadingRules = isLoading;
    }
  },

  actions: {
    // =============== LOYALTY SETTINGS ACTIONS ===============
    async GET_ALL_LOYALTY_SETTINGS({ commit }, payload = {}) {
      commit('SET_LOYALTY_SETTINGS_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.get('loyalty/settings', {
          headers: { 'Authorization': 'Bearer ' + token },
          params: payload
        });
        
        commit(GET_ALL_LOYALTY_SETTINGS, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar configurações de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_SETTINGS_LOADING', false);
      }
    },

    async GET_LOYALTY_SETTINGS({ commit }, id) {
      commit('SET_LOYALTY_SETTINGS_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.get(`loyalty/settings/${id}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(GET_LOYALTY_SETTINGS, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar configuração de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_SETTINGS_LOADING', false);
      }
    },

    async GET_LOYALTY_SETTINGS_BY_ENTERPRISE({ commit }, enterpriseId) {
      commit('SET_LOYALTY_SETTINGS_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.get(`loyalty/settings/enterprise/${enterpriseId}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(GET_LOYALTY_SETTINGS, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar configurações por empresa:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_SETTINGS_LOADING', false);
      }
    },

    async ADD_LOYALTY_SETTINGS({ commit }, payload) {
      commit('SET_LOYALTY_SETTINGS_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.post('loyalty/settings', payload, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(ADD_LOYALTY_SETTINGS, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao criar configuração de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_SETTINGS_LOADING', false);
      }
    },

    async UPDATE_LOYALTY_SETTINGS({ commit }, { id, data }) {
      commit('SET_LOYALTY_SETTINGS_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.put(`loyalty/settings/${id}`, data, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(UPDATE_LOYALTY_SETTINGS, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao atualizar configuração de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_SETTINGS_LOADING', false);
      }
    },

    async DELETE_LOYALTY_SETTINGS({ commit }, id) {
      commit('SET_LOYALTY_SETTINGS_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        await axiosautomacao.delete(`loyalty/settings/${id}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(DELETE_LOYALTY_SETTINGS, id);
        return true;
      } catch (error) {
        console.error('Erro ao deletar configuração de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_SETTINGS_LOADING', false);
      }
    },

    // =============== LOYALTY RULES EARN ACTIONS ===============
    async GET_ALL_LOYALTY_RULES_EARN({ commit }, payload = {}) {
      commit('SET_LOYALTY_RULES_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.get('loyalty/rules-earn', {
          headers: { 'Authorization': 'Bearer ' + token },
          params: payload
        });
        
        commit(GET_ALL_LOYALTY_RULES_EARN, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar regras de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_RULES_LOADING', false);
      }
    },

    async GET_LOYALTY_RULES_EARN({ commit }, id) {
      commit('SET_LOYALTY_RULES_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.get(`loyalty/rules-earn/${id}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(GET_LOYALTY_RULES_EARN, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar regra de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_RULES_LOADING', false);
      }
    },

    async GET_LOYALTY_RULES_EARN_BY_ENTERPRISE({ commit }, enterpriseId) {
      commit('SET_LOYALTY_RULES_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.get(`loyalty/rules-earn/enterprise/${enterpriseId}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(GET_ALL_LOYALTY_RULES_EARN, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar regras por empresa:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_RULES_LOADING', false);
      }
    },

    async ADD_LOYALTY_RULES_EARN({ commit }, payload) {
      commit('SET_LOYALTY_RULES_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.post('loyalty/rules-earn', payload, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(ADD_LOYALTY_RULES_EARN, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao criar regra de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_RULES_LOADING', false);
      }
    },

    async UPDATE_LOYALTY_RULES_EARN({ commit }, { id, data }) {
      commit('SET_LOYALTY_RULES_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.put(`loyalty/rules-earn/${id}`, data, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(UPDATE_LOYALTY_RULES_EARN, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao atualizar regra de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_RULES_LOADING', false);
      }
    },

    async DELETE_LOYALTY_RULES_EARN({ commit }, id) {
      commit('SET_LOYALTY_RULES_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        await axiosautomacao.delete(`loyalty/rules-earn/${id}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        commit(DELETE_LOYALTY_RULES_EARN, id);
        return true;
      } catch (error) {
        console.error('Erro ao deletar regra de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_RULES_LOADING', false);
      }
    },

    // =============== CUSTOMER ACTIONS (EXISTING) ===============
    async REDEEM_LOYALTY_POINTS({ commit }, payload) {
      commit('SET_LOYALTY_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.post('loyalty/redeem-points', payload, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        
        return response.data;
      } catch (error) {
        console.error('Erro ao resgatar pontos de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_LOADING', false);
      }
    },

    async GET_LOYALTY_LEDGER({ commit }, payload) {
      commit('SET_LOYALTY_LOADING', true);
      let token = localStorage.getItem("token_gestao");
      
      try {
        const response = await axiosautomacao.get(`loyalty/customer/${payload.client_id}/ledger/${payload.enterprise_id}`, {
          headers: { 'Authorization': 'Bearer ' + token },
          params: {
            page: payload.page || 1,
            limit: payload.limit || 15
          }
        });
        
        commit(GET_LOYALTY_LEDGER, response.data);
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar extrato de fidelidade:', error);
        throw error;
      } finally {
        commit('SET_LOYALTY_LOADING', false);
      }
    }
  },

  getters: {
    // Settings getters
    getAllLoyaltySettings: (state) => state.allLoyaltySettings,
    getSelectedLoyaltySettings: (state) => state.selectedLoyaltySettings,
    getLoyaltySettings: (state) => state.loyaltySettings, // Keep for backwards compatibility
    
    // Rules Earn getters
    getAllLoyaltyRulesEarn: (state) => state.allLoyaltyRulesEarn,
    getSelectedLoyaltyRulesEarn: (state) => state.selectedLoyaltyRulesEarn,
    
    // Customer getters
    getLoyaltyLedger: (state) => state.loyaltyLedger,
    
    // Loading getters
    isLoyaltyLoading: (state) => state.isLoading,
    isLoyaltySettingsLoading: (state) => state.isLoadingSettings,
    isLoyaltyRulesLoading: (state) => state.isLoadingRules,
  },
};

export default moduleLoyalty;